export default __webpack_public_path__ + "static/media/delkor.a88c3ad7.png";